module.exports = __webpack_public_path__ + "static/Contact-6cdffe023deacafb12c096b11f72bd24.jpg";